import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-tile',
    templateUrl: './smart-assistant-tile.component.html'
})
export class SmartAssistantTileComponent {
    @Input() cardTitle: string;
    @Input() cardSubtitle: string;
    @Input() buttonText = $localize`Start now`;

    @Input() loading = false;

    @Output() tileClicked = new EventEmitter<void>();

    onClick() {
        this.tileClicked.emit();
    }
}
